import {
  getAIArtWork_pictureGraph_aiArtwork,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  SuperType,
  getShareInfo_pictureGraph_aiArtworkSharingInfo_sharingAiArtwork,
} from '~/graphqls/types'
import { setStorage } from '~/utils'

export type Product =
  | (Omit<
      getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
      '__typename'
    > & {
      trackEventLabel?: string | null
    })
  | (Omit<getAIArtWork_pictureGraph_aiArtwork, '_typename'> & {
    trackEventLabel?: string | null
    })
  | (Omit<
      getShareInfo_pictureGraph_aiArtworkSharingInfo_sharingAiArtwork,
      '_typename'
    > & {
      trackEventLabel?: string | null
    })

/** 设置再来一张的底层参数 */
export function setAgainParams(item: Product) {
  console.log(item, 'item')
  setStorage('aiParam', {
    prompt: item.prompt,
    promptOptimize: item.promptOptimize === 1 ? true : false,
    model: item.model,
    size: item.size,
    resolution: `${item.length}*${item.width}*${item.superType}`,
    modelTheme: [
      {
        name: item.modelTheme,
        modelCode: item.modelCode,
      },
    ],
    character: item.characterOptions?.map(item => item.key),
    modelFusion: item.modelFusionOptions?.map(item => ({
      key: item.key,
      weight: item.weight,
    })),
    styleDecorationOptions: item.styleDecorationOptions?.map(item => ({
      key: item.key,
      type: item.type,
    })),
    initImageUrl: item.initImageUrl,
    creativityDegree: item.creativityDegree,
    maskImageUrl: item.maskImageUrl,
    maskZoneImageUrl: item.maskZoneImageUrl,
    originUrl: item.miniArtWorkUrl,
    modelCode: item.modelCode,
    ucPrompt: item.ucPrompt,
    doRepairTheHand: item.doRepairTheHand,
    createSource: item.createSource || 0,
    cfg: item?.cfg,
    pretreatmentMethod: item.pretreatmentMethod || undefined,
    samplerModelInfo: item?.samplerModelInfo || undefined,
    superType: item?.superType || SuperType.SUPERSIZE,
    // 访问来源，用于统计该渠道来源
    trackEventLabel: item?.trackEventLabel || undefined,
  })
}
